import React, { useState } from "react";
import "./ContactUs.css";
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ContactUs() {
  const[formdata,setFormData] = useState({
    name:"",
    email:"",
    subject:"",
    message:""
  })
  const updateData = (e)=>{
    setFormData({
      ...formdata,
      [e.target.name]: e.target.value[0] === ' ' ? '' : e.target.value,
    });
  }
  const submitMail = (e)=>{
    e.preventDefault();
    emailjs.sendForm("service_lmd4bf2","template_mv54njq",e.target,"N6t6o-U7w8YQa3PgB").then((res)=>{
      console.log("Email sent successfully", res)
      toast.success("Thank you,we will contact with you soon")
      setFormData({name:"",email:"",subject:"",message:""})
    },((err)=>{
      console.log("Email could not be sent",err)
      toast.error("Email could not be sent")
    }))
  }
  return (
    <section id="contact" class="contact">
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <h2>Contact</h2>
          <p className="contact-para">
          Connect with Us Today: Your Questions, Our Answers.
          </p>
        </div>

        <div class="row justify-content-center">
          <div class="col-lg-12 col-md-12 col-sm-11 col-11 mt-5 mt-lg-0 form-box">
            <form onSubmit={submitMail}>
            <div class="row">
              <div class="form-group col-lg-6">
                <label for="name">Your Name</label>
                <input
                  type="text"
                  name="name"
                  class="form-control"
                  id="name"
                  required
                  value={formdata.name}
                  onChange={updateData}
                />
              </div>
              <div class="form-group col-lg-6">
                <label for="name">Your Email</label>
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  id="email"
                  required
                  value={formdata.email}
                  onChange={updateData}
                />
              </div>
            </div>
            <div className="row">
              <div class="form-group col-lg-12">
                <label for="name">Subject</label>
                <input
                  type="text"
                  class="form-control"
                  name="subject"
                  id="subject"
                  required
                  value={formdata.subject}
                  onChange={updateData}
                />
              </div>
              <div class="form-group col-lg-12">
                <label for="name">Message</label>
                <textarea
                  class="form-control"
                  name="message"
                  required
                  value={formdata.message}
                  onChange={updateData}
                ></textarea>
              </div>
            </div>
            <div class="text-center">
              <button type="submit">Send Message</button>
            </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
}
